// @ts-nocheck

//////////////////////////////////////
//   This file is auto generated   //
//////////////////////////////////////

import * as System_Collections_Generic from "./System_Collections_Generic"
import * as System from "./System"
import * as Theasoft_DataClasses_Dispo from "./Theasoft_DataClasses_Dispo"

export type GetMyStatus_Request = {
  dates: System_Collections_Generic.List<System.DateOnly>
}

export type eCalendarAppointmentSource = "PersonStatus" | "PossibleCast" | "Duty" | "Cast"
export const eCalendarAppointmentSource_AllValues = ["PersonStatus", "PossibleCast", "Duty", "Cast"] as const
export const defaulteCalendarAppointmentSource: eCalendarAppointmentSource = "PersonStatus"

export type CalendarAppointment = {
  source: eCalendarAppointmentSource
  id: System.Nullable<System.Int32>
  start: System.Nullable<System.TimeOnly>
  end: System.Nullable<System.TimeOnly>
  title: System.String
  location: System.String
  type: System.String
  status: System.String
  statusColor: System.String
  isLikeRequest: System.Boolean
  description: System.String
  blockColorHEX: System.String
  backColorHEX: System.String
  foreColorHEX: System.String
  additionalCastTimes: System_Collections_Generic.List<Theasoft_DataClasses_Dispo.CastTime>
  isPublicEvent: System.Boolean
  countingValue: System.Single
}

export type eAppointmentCountingMethod = "NoCount" | "AllCount" | "Performance" | "Duties"
export const eAppointmentCountingMethod_AllValues = ["NoCount", "AllCount", "Performance", "Duties"] as const
export const defaulteAppointmentCountingMethod: eAppointmentCountingMethod = "NoCount"

export type GetMyActivitiesRequest = {
  date: System.DateOnly
  method: eAppointmentCountingMethod
}

export type GetMyActivities_Request = {
  requests: System_Collections_Generic.List<GetMyActivitiesRequest>
}

export type GetMyDuties_Request = {
  dates: System_Collections_Generic.List<System.DateOnly>
}

export type DateRangeRequest = {
  startDate: System.DateOnly
  endDate: System.DateOnly
}

export type EventsRangeRequest = {
  startDate: System.DateOnly
  endDate: System.DateOnly
  method: eAppointmentCountingMethod
  onlyReleasedDuties: System.Boolean
  withPossibleCasts: System.Boolean
  withPersStatus: System.Boolean
}


